/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class DialogsEvents {
}
DialogsEvents.DIALOG_CLOSED = 'dell.sirius.dialogs.dialog.closed';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlhbG9ncy1ldmVudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvc2hhcmVkL2RpYWxvZ3MvZXZlbnRzL2RpYWxvZ3MtZXZlbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLGFBQWE7O0FBQ0MsMkJBQWEsR0FBRyxtQ0FBbUMsQ0FBQyJ9